import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { ReactNode } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "4px",
  border: "1px solid #ccc",
};

interface IBasicModalProps {
  title?: string;
  text?: string;
  open: boolean;
  onClose: () => void;
  requesting?: boolean;
  isAcceptable?: boolean;
  acceptButtonText?: string;
  onAccept?: void;
  isCancelable?: boolean;
  cancelbuttonText?: string;
  onCancel?: void;
  size?: "small" | "medium" | "large" | "fullScreen";
  isLock?: boolean;
  hideCloseIcon?: boolean;

  children?: ReactNode;
}

export default function BasicModal(props: IBasicModalProps) {
  const { open, onClose, children } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>{children}</Box>
      </Modal>
    </div>
  );
}
